import {TabPanel, TabView} from "primereact/tabview";
import useSessionState from "../../hooks/useSessionState";
import '../../operaciones/operaciones.css';
import ControlPatioIpad from "./controlPatiosInventarioCajasIpad";

const ControlPatiosInventarioCajasSeccion = () => {
    const [activeIndex,setActiveIndex] = useSessionState('tabControlPatiosCajas', 0);
    return (
        <>        
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="main-tab-view">       
                <TabPanel headerStyle ={  {display:"inline"} }  header="IPAD">
                    <ControlPatioIpad/>
                </TabPanel>
               
            </TabView>
   
         </>
    )
};

export default ControlPatiosInventarioCajasSeccion;
